<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="review"
                 :is-loading="isLoading"
                 :review="review"
                 :reviews="nominationReviews"
                 :nomination-report="nominationReport"
                 :award-report="awardReport"
                 class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  IfacAwardDetails,
  IfacNominationDetails,
  IfacNominationReferences,
  IfacReviewDetails,
} from '@ifac/ui';
import referencesMixin from '@/mixins/awards/references.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';
import Reviews from '@/services/Api/Awards/Reviews';

export default {
  mixins: [referencesMixin],
  name: 'ReviewsEditPortal',
  components: {
    ParentPortal,
    IfacNominationDetails,
    IfacReviewDetails,
  },
  created() {
    this.fetchReview();
  },
  data() {
    return {
      nomination: null,
      review: null,
      nominationReport: null,
      nominationReviews: [],
      awardReport: null,
      isLoading: false,
    };
  },
  methods: {
      fetchReview() {
        const params = {
          relations: ['nomination.award', 'reviews.nomination'],
        };

        this.isLoading = true;
        Reviews.get(this.$route.params.review, params).then((response) => {
          this.review = response.data.data;
          this.fetchNominationReviews();
        }).finally(() => {
          this.isLoading = false;
        });
      },
    fetchNominationReviews() {
      const params = {
        nomination_id: this.review.nomination_id,
        relations: ['affiliate'],
      };

      return Reviews.all(params).then((response) => {
        this.nominationReviews = response.data.data;
      });
    },
  },
  computed: {
    reviewId() {
      return this.$route.params.review;
    },
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      const tabs = [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.review?.nomination?.award,
            isLoading: false,
          },
        },
        {
          icon: ['far', 'user-check'],
          headerText: 'Nomination',
          component: IfacNominationDetails,
          options: {
            nomination: this.review?.nomination,
            review: this.review,
            isLoading: false,
          },
        },
      ];

      // Reference Letters
      if (this.review?.nomination?.can.viewReferences) {
        tabs.push({
          icon: ['far', 'envelope'],
          headerText: 'Reference letters',
          component: IfacNominationReferences,
          options: {
            nomination: this.review.nomination,
            isLoading: false,
          },
        });
      }

      // Reviewers
      const nomination = this.review?.nomination;

      if (this.review?.can.viewReviewers === true || nomination?.can.viewReviewsCount === true) {
        tabs.push({
          icon: ['far', 'users'],
          headerText: 'Reviewers',
          component: IfacReviewDetails,
          options: {
            review: this.review,
            reviews: this.nominationReviews,
            isLoading: false,
          },
        });
      }

      return tabs;
    },
  },
  watch: {
    reviewId() {
      this.fetchReview();
    },
  },
};
</script>
